module.exports = __webpack_public_path__ + "img/cross.574b2d43.png";